// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.research-form-options {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;
  align-items: center;
  padding: 0;
  margin-left: 0;
  transition: gap 0.3s ease;
  max-width: 100%;
  overflow-x: visible;
  flex: 1 1;
  min-width: 0;
}
@media (min-width: 1200px) {
  .research-form-options {
    padding-left: 0;
    margin-left: 0;
  }
}
@media screen and (max-width: 768px) {
  .research-form-options {
    padding: 0 4px;
    gap: 6px;
  }
}
@media screen and (max-width: 576px) {
  .research-form-options {
    padding: 0 2px;
    gap: 4px;
  }
}
.research-form-options .report-date-picker-wrapper {
  position: relative;
  display: flex;
  align-items: stretch;
  flex-shrink: 0;
  transition: all 0.3s ease;
}
.research-form-options .report-date-picker-wrapper.date-updated {
  animation: date-picker-pulse 2.2s ease-out forwards;
}
.research-form-options .report-date-picker-wrapper[data-tooltip]:not([data-tooltip=""]) {
  --tooltip-bg-color: #000;
  --tooltip-text-color: #fff;
}
.research-form-options .report-date-picker-wrapper[data-tooltip]:not([data-tooltip=""]):after {
  visibility: hidden;
  content: attr(data-tooltip);
  position: absolute;
  border-style: solid;
  border-color: transparent transparent var(--tooltip-bg-color) transparent;
  min-width: -webkit-max-content;
  min-width: max-content;
  background-color: var(--tooltip-bg-color);
  color: var(--tooltip-text-color);
  text-align: center;
  font-family: var(--primary-font);
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.4;
  padding: 6px 8px;
  border-radius: 6px;
  top: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  max-height: 0;
  opacity: 0.9;
  z-index: 15;
  white-space: nowrap;
  display: none;
  justify-content: center;
  align-items: center;
  max-width: 400px;
  width: auto;
}
.research-form-options .report-date-picker-wrapper[data-tooltip]:not([data-tooltip=""]):before {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  visibility: hidden;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent var(--tooltip-bg-color) transparent;
  z-index: 16;
}
.research-form-options .report-date-picker-wrapper[data-tooltip]:not([data-tooltip=""]):hover:after, .research-form-options .report-date-picker-wrapper[data-tooltip]:not([data-tooltip=""]):hover:before {
  visibility: visible;
  max-height: auto;
  display: inline-flex;
}
.research-form-options .report-date-picker-wrapper.mobile {
  width: auto;
}
.research-form-options .report-date-picker-wrapper.is-locked .rs-picker-toggle {
  cursor: not-allowed;
}
.research-form-options .report-date-picker-wrapper.is-locked::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 10px;
  background: rgba(74, 74, 74, 0.45);
  pointer-events: none;
  z-index: 2;
}
@media screen and (max-width: 992px) {
  .research-form-options .report-date-picker-wrapper.is-locked::after {
    border-radius: 50%;
  }
}
.research-form-options .report-date-range-picker-mobile {
  display: none;
}
.research-form-options .report-date-range-picker .rs-picker-toggle,
.research-form-options .report-date-range-picker .rs-input,
.research-form-options .report-date-range-picker-mobile .rs-picker-toggle,
.research-form-options .report-date-range-picker-mobile .rs-input {
  cursor: pointer;
  transition: all 0.3s ease;
}
.research-form-options .report-date-range-picker {
  max-width: 240px;
}
.research-form-options .report-date-range-picker .rs-input-group {
  width: 100%;
}
@media screen and (max-width: 576px) {
  .research-form-options {
    gap: 5px;
  }
}
@media screen and (max-width: 992px) {
  .research-form-options {
    gap: 5px;
  }
  .research-form-options .report-date-range-picker {
    display: none;
  }
  .research-form-options .report-date-range-picker-mobile {
    display: block;
  }
  .research-form-options .report-date-range-picker-mobile .rs-picker-input-group,
  .research-form-options .report-date-range-picker-mobile .rs-input-group {
    width: 40px !important;
    height: 40px !important;
    min-width: 40px;
    border-radius: 50% !important;
    padding: 0 !important;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--primary-color-light-500);
    border: 1px solid var(--rs-border-primary);
    box-shadow: 2px 3px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
  }
  .research-form-options .report-date-range-picker-mobile .rs-date-range-input,
  .research-form-options .report-date-range-picker-mobile .rs-input {
    display: none !important;
  }
  .research-form-options .report-date-range-picker-mobile .rs-input-group-addon {
    padding: 0 !important;
    margin: 0 !important;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background: transparent !important;
    border: none !important;
    transition: all 0.3s ease;
  }
  .research-form-options .report-date-range-picker-mobile .rs-input-group-addon .rs-icon {
    width: 20px;
    height: 20px;
    color: var(--primary-color-600);
  }
}
@media screen and (max-width: 992px) and (max-width: 576px) {
  .research-form-options .report-date-range-picker-mobile .rs-picker-input-group,
  .research-form-options .report-date-range-picker-mobile .rs-input-group {
    width: 36px !important;
    height: 36px !important;
    min-width: 36px;
  }
  .research-form-options .report-date-range-picker-mobile .rs-input-group-addon .rs-icon {
    width: 18px;
    height: 18px;
  }
}
@media screen and (max-width: 992px) {
  .research-form-options .rs-picker-daterange > .rs-input-group.rs-input-group-inside .rs-input {
    padding: 0.3em 0.5em;
  }
}
@media screen and (max-width: 992px) {
  .research-form-options .framework-dropdown .ui-dropdown-button[data-tooltip]:after {
    transform: translateX(-15%);
  }
}

/* Anchor for conversation history popup */
.conversation-history-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

@keyframes date-picker-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.8);
    border-radius: 8px;
  }
  30% {
    box-shadow: 0 0 0 6px rgba(59, 130, 246, 0.4);
    border-radius: 8px;
  }
  60% {
    box-shadow: 0 0 0 10px rgba(59, 130, 246, 0.1);
    border-radius: 8px;
  }
  100% {
    box-shadow: 0 0 0 14px rgba(59, 130, 246, 0);
    border-radius: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/layouts/user/Research/components/ResearchNavBar/ResearchNavBar.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AACF;AACE;EAdF;IAeI,eAAA;IACA,cAAA;EAEF;AACF;AACE;EApBF;IAqBI,cAAA;IACA,QAAA;EAEF;AACF;AAAE;EAzBF;IA0BI,cAAA;IACA,QAAA;EAGF;AACF;AADE;EACE,kBAAA;EACA,aAAA;EACA,oBAAA;EACA,cAAA;EACA,yBAAA;AAGJ;AADI;EACE,mDAAA;AAGN;AAAI;EACE,wBAAA;EACA,0BAAA;AAEN;AAAM;EACE,kBAAA;EACA,2BAAA;EACA,kBAAA;EAEA,mBAAA;EACA,yEAAA;EACA,8BAAA;EAAA,sBAAA;EACA,yCAAA;EACA,gCAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AACR;AAEM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yEAAA;EACA,WAAA;AAAR;AAIQ;EACE,mBAAA;EACA,gBAAA;EACA,oBAAA;AAFV;AAOI;EACE,WAAA;AALN;AASM;EACE,mBAAA;AAPR;AAUM;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,mBAAA;EACA,kCAAA;EACA,oBAAA;EACA,UAAA;AARR;AAYM;EACE;IACE,kBAAA;EAVR;AACF;AAeE;EACE,aAAA;AAbJ;AAkBI;;;;EAEE,eAAA;EACA,yBAAA;AAdN;AAkBE;EACE,gBAAA;AAhBJ;AAkBI;EACE,WAAA;AAhBN;AAoBE;EAnJF;IAoJI,QAAA;EAjBF;AACF;AAmBE;EAvJF;IAwJI,QAAA;EAhBF;EAkBE;IACE,aAAA;EAhBJ;EAmBE;IACE,cAAA;EAjBJ;EAoBI;;IAEE,sBAAA;IACA,uBAAA;IACA,eAAA;IACA,6BAAA;IACA,qBAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,gDAAA;IACA,0CAAA;IACA,0CAAA;IACA,yBAAA;EAlBN;EAsBI;;IAEE,wBAAA;EApBN;EAwBI;IACE,qBAAA;IACA,oBAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,YAAA;IACA,kCAAA;IACA,uBAAA;IACA,yBAAA;EAtBN;EAwBM;IACE,WAAA;IACA,YAAA;IACA,+BAAA;EAtBR;AACF;AA2BI;EAEI;;IAEE,sBAAA;IACA,uBAAA;IACA,eAAA;EA1BR;EA6BM;IACE,WAAA;IACA,YAAA;EA3BR;AACF;AAiCI;EADF;IAEI,oBAAA;EA9BJ;AACF;AAoCM;EACE;IACE,2BAAA;EAlCR;AACF;;AAwCA,0CAAA;AACA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;AArCF;;AAwCA;EACE;IAAO,2CAAA;IAA6C,kBAAA;EAnCpD;EAoCA;IAAO,6CAAA;IAA+C,kBAAA;EAhCtD;EAiCA;IAAO,8CAAA;IAAgD,kBAAA;EA7BvD;EA8BA;IAAO,4CAAA;IAA8C,kBAAA;EA1BrD;AACF","sourcesContent":[".research-form-options {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  gap: 10px;\n  align-items: center;\n  padding: 0; // Remove side padding to align with content edge\n  margin-left: 0;\n  transition: gap 0.3s ease;\n  max-width: 100%;\n  overflow-x: visible;\n  flex: 1;\n  min-width: 0; // Allow shrinking\n\n  @media (min-width: 1200px) {\n    padding-left: 0;\n    margin-left: 0;\n  }\n\n  // Prevent content overflow on small screens\n  @media screen and (max-width: 768px) {\n    padding: 0 4px;\n    gap: 6px;\n  }\n\n  @media screen and (max-width: 576px) {\n    padding: 0 2px;\n    gap: 4px;\n  }\n\n  .report-date-picker-wrapper {\n    position: relative;\n    display: flex;\n    align-items: stretch;\n    flex-shrink: 0;\n    transition: all 0.3s ease;\n\n    &.date-updated {\n      animation: date-picker-pulse 2.2s ease-out forwards;\n    }\n    // Tooltip styles - matching History button exactly\n    &[data-tooltip]:not([data-tooltip=\"\"]) {\n      --tooltip-bg-color: #000;\n      --tooltip-text-color: #fff;\n\n      &:after {\n        visibility: hidden;\n        content: attr(data-tooltip);\n        position: absolute;\n        \n        border-style: solid;\n        border-color: transparent transparent var(--tooltip-bg-color) transparent;\n        min-width: max-content;\n        background-color: var(--tooltip-bg-color);\n        color: var(--tooltip-text-color);\n        text-align: center;\n        font-family: var(--primary-font);\n        font-size: 0.875rem;\n        font-weight: 500;\n        line-height: 1.4;\n        padding: 6px 8px;\n        border-radius: 6px;\n        top: calc(100% + 10px);\n        left: 50%;\n        transform: translateX(-50%);\n        max-height: 0;\n        opacity: .9;\n        z-index: 15;\n        white-space: nowrap;\n        display: none;\n        justify-content: center;\n        align-items: center;\n        max-width: 400px;\n        width: auto;\n      }\n\n      &:before {\n        content: \"\";\n        position: absolute;\n        top: 100%;\n        left: 50%;\n        transform: translateX(-50%);\n        visibility: hidden;\n        border-width: 5px;\n        border-style: solid;\n        border-color: transparent transparent var(--tooltip-bg-color) transparent;\n        z-index: 16;\n      }\n\n      &:hover {\n        &:after, &:before {\n          visibility: visible;\n          max-height: auto;\n          display: inline-flex;\n        }\n      }\n    }\n\n    &.mobile {\n      width: auto;\n    }\n\n    &.is-locked {\n      .rs-picker-toggle {\n        cursor: not-allowed;\n      }\n\n      &::after {\n        content: '';\n        position: absolute;\n        inset: 0;\n        border-radius: 10px;\n        background: rgba(74, 74, 74, 0.45);\n        pointer-events: none;\n        z-index: 2;\n      }\n\n      // Circular button when locked on mobile\n      @media screen and (max-width: 992px) {\n        &::after {\n          border-radius: 50%;\n        }\n      }\n    }\n  }\n\n  .report-date-range-picker-mobile {\n    display: none;\n  }\n\n  .report-date-range-picker,\n  .report-date-range-picker-mobile {\n    .rs-picker-toggle,\n    .rs-input {\n      cursor: pointer;\n      transition: all 0.3s ease;\n    }\n  }\n\n  .report-date-range-picker {\n    max-width: 240px;\n    \n    .rs-input-group {\n      width: 100%;\n    }\n  }\n\n  @media screen and (max-width: 576px) {\n    gap: 5px;\n  }\n\n  @media screen and (max-width: 992px) {\n    gap: 5px;\n\n    .report-date-range-picker {\n      display: none;\n    }\n\n    .report-date-range-picker-mobile {\n      display: block;\n\n      // Make it a circular icon button on mobile\n      .rs-picker-input-group,\n      .rs-input-group {\n        width: 40px !important;\n        height: 40px !important;\n        min-width: 40px;\n        border-radius: 50% !important;\n        padding: 0 !important;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-color: var(--primary-color-light-500);\n        border: 1px solid var(--rs-border-primary);\n        box-shadow: 2px 3px 4px rgba(0,0,0, 0.1);\n        transition: all 0.3s ease;\n      }\n\n      // Hide the text input, show only the calendar icon\n      .rs-date-range-input,\n      .rs-input {\n        display: none !important;\n      }\n\n      // Style the calendar icon\n      .rs-input-group-addon {\n        padding: 0 !important;\n        margin: 0 !important;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 100%;\n        height: 100%;\n        background: transparent !important;\n        border: none !important;\n        transition: all 0.3s ease;\n\n        .rs-icon {\n          width: 20px;\n          height: 20px;\n          color: var(--primary-color-600);\n        }\n      }\n    }\n\n    // Smaller on very small screens\n    @media screen and (max-width: 576px) {\n      .report-date-range-picker-mobile {\n        .rs-picker-input-group,\n        .rs-input-group {\n          width: 36px !important;\n          height: 36px !important;\n          min-width: 36px;\n        }\n\n        .rs-input-group-addon .rs-icon {\n          width: 18px;\n          height: 18px;\n        }\n      }\n    }\n  }\n\n  .rs-picker-daterange > .rs-input-group.rs-input-group-inside .rs-input {\n    @media screen and (max-width: 992px) {\n      padding: 0.3em 0.5em;\n    }\n  }\n\n  // Shift framework dropdown tooltip to the right on small screens to prevent clipping\n  .framework-dropdown {\n    .ui-dropdown-button {\n      @media screen and (max-width: 992px) {\n        &[data-tooltip]:after {\n          transform: translateX(-15%); // Shift right from center\n        }\n      }\n    }\n  }\n}\n\n/* Anchor for conversation history popup */\n.conversation-history-wrapper {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n  transition: all 0.3s ease;\n}\n\n@keyframes date-picker-pulse {\n  0%   { box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.8); border-radius: 8px; }\n  30%  { box-shadow: 0 0 0 6px rgba(59, 130, 246, 0.4); border-radius: 8px; }\n  60%  { box-shadow: 0 0 0 10px rgba(59, 130, 246, 0.1); border-radius: 8px; }\n  100% { box-shadow: 0 0 0 14px rgba(59, 130, 246, 0); border-radius: 8px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
